module.exports = __webpack_public_path__ + "img/circle-b.112cd521.svg";